import styled from 'styled-components';

export const TicketTextInfoWarp = styled.div`
    /* margin-top: 8px; */
    padding: 0 16px;
    background-color: #fff;
    white-space: pre-wrap;

    img {
        width: 100%;
    }
`;

export const TicketTextInfoContent = styled.div`
    padding: 16px 0;
    ${(props) => !props.isLastItem && `border-bottom: 1px solid rgba(0, 0, 0, 0.1);`}
`;
